import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { RedoCollapseSubsection } from "@redotech/arbiter/collapse/redo-collapse-section";
import { Flex } from "@redotech/arbiter/flex";
import { RedoTextareaInputField } from "@redotech/arbiter/input/redo-textarea-input-field";
import { Text } from "@redotech/arbiter/text";
import UploadCloudIcon from "@redotech/redo-icons/upload-cloud-02.svg";
import { memo } from "react";
import { useGorgiasViewsImport } from "../../gorgias-import/use-gorgias-import";

export const GorgiasViewsTab = memo(function GorgiasViewsTab({
  teamId,
}: {
  teamId: string | undefined;
}) {
  const {
    viewSectionsJsonText,
    setViewSectionsJsonText,
    viewsJsonText,
    setViewsJsonText,
    loading,
    handleImport,
  } = useGorgiasViewsImport({ teamId });

  const canImport =
    viewSectionsJsonText.trim() && viewsJsonText.trim() && !loading;

  return (
    <Flex dir="column" gap="lg">
      <Text fontSize="sm" textColor="secondary">
        Import views and view folders from Gorgias. Paste the JSON responses
        from the Gorgias API endpoints below.
      </Text>
      <RedoCollapseSubsection title="Instructions">
        <Flex dir="column" gap="sm" pl="lg">
          <Text fontSize="sm" textColor="secondary">
            To add this import:
          </Text>
          <Text fontSize="sm" textColor="secondary">
            <li>
              • Go to Gorgias and open your developer tools (right click,
              inspect)
            </li>
            <li>• Go to the network tab</li>
            <li>• Go to the main inbox in Gorgias</li>
            <li>
              • Search for "view-sections" and copy the response into the View
              Sections JSON input
            </li>
            <li>
              • Search for "views" and copy the response into the Views JSON
              input
            </li>
          </Text>
        </Flex>
      </RedoCollapseSubsection>
      <Flex dir="column" gap="md">
        <RedoTextareaInputField
          disabled={loading}
          label="View sections JSON (Folders)"
          placeholder='Paste Gorgias view-sections JSON here (e.g., {"object": "list", "data": [...]})'
          setValue={setViewSectionsJsonText}
          value={viewSectionsJsonText}
        />
        <RedoTextareaInputField
          disabled={loading}
          label="Views JSON"
          placeholder='Paste Gorgias views JSON here (e.g., {"object": "list", "data": [...]})'
          setValue={setViewsJsonText}
          value={viewsJsonText}
        />
      </Flex>
      <div>
        <RedoButton
          disabled={!canImport}
          hierarchy="primary"
          IconLeading={UploadCloudIcon}
          onClick={handleImport}
          pending={loading}
          size="md"
          text="Import views"
          theme="normal"
        />
      </div>
    </Flex>
  );
});
